import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { PingInterceptor } from './ping-interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: PingInterceptor, multi: true },
];